import { NAME } from './constants';

export const isLoaded = globalState => (globalState[NAME] && globalState[NAME].loaded);
export const error = globalState => (globalState[NAME] && globalState[NAME].error);



// WEBPACK FOOTER //
// ./src/redux/modules/flick/selectors.js